import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['track', 'slide', 'dot']
  static values = {
    interval: { type: Number, default: 3000 }
  }

  connect () {
    if (this.slideTargets.length < 2) return

    this.index = 0
    this.scrollToIndex(0, 'auto')
    this.updateDots()
    this.startTimer()

    this.element.addEventListener('mouseenter', this.pause)
    this.element.addEventListener('mouseleave', this.resume)
  }

  disconnect () {
    this.stopTimer()
    this.element.removeEventListener('mouseenter', this.pause)
    this.element.removeEventListener('mouseleave', this.resume)
  }

  pause = () => {
    this.stopTimer()
  }

  resume = () => {
    if (this.slideTargets.length < 2) return
    this.startTimer()
  }

  prev () {
    this.goTo((this.index - 1 + this.slideTargets.length) % this.slideTargets.length)
  }

  next () {
    this.goTo((this.index + 1) % this.slideTargets.length)
  }

  goTo (event) {
    const index = typeof event === 'number' ? event : Number(event.currentTarget.dataset.promotedSliderIndex)
    if (Number.isNaN(index)) return

    this.index = index
    this.scrollToIndex(this.index)
    this.updateDots()
    this.restartTimer()
  }

  advance () {
    this.index = (this.index + 1) % this.slideTargets.length
    this.scrollToIndex(this.index)
    this.updateDots()
  }

  scrollToIndex (index, behavior = 'smooth') {
    const slide = this.slideTargets[index]
    const track = this.trackTarget
    if (!slide || !track) return

    const maxScroll = track.scrollWidth - track.clientWidth
    const scrollLeft = Math.min(maxScroll, Math.max(0, slide.offsetLeft))

    track.scrollTo({ left: scrollLeft, behavior })
  }

  updateDots () {
    if (!this.hasDotTarget) return

    this.dotTargets.forEach((dot, i) => {
      const active = i === this.index
      dot.classList.toggle('bg-slate-900', active)
      dot.classList.toggle('w-5', active)
      dot.classList.toggle('bg-slate-300', !active)
      dot.classList.toggle('w-1.5', !active)
      dot.setAttribute('aria-current', active ? 'true' : 'false')
    })
  }

  startTimer () {
    this.stopTimer()
    this.timer = window.setInterval(() => this.advance(), this.intervalValue)
  }

  restartTimer () {
    if (this.slideTargets.length < 2) return
    this.startTimer()
  }

  stopTimer () {
    if (this.timer) {
      window.clearInterval(this.timer)
      this.timer = null
    }
  }
}
